import React from "react";
import "./progress-section.scss";

// Indicateur des trois grandes étapes du parcours (Identification, RDO,
// Récapitulatif). Liste ordonnée nommée (pas de repère `nav` : les étapes ne
// sont pas des liens). L'étape en cours porte aria-current ; les étapes
// précédentes sont « terminées » (coche + texte pour lecteur d'écran), les
// suivantes « à venir ». La position « Étape N sur M » est annoncée en toutes
// lettres pour ne pas reposer sur la seule couleur des repères.
const ProgressSection = ({ sections }) => {
  const currentIndex = sections.findIndex((s) => s.active);
  const total = sections.length;

  const statusOf = (index) => {
    if (currentIndex === -1 || index > currentIndex) return "upcoming";
    return index === currentIndex ? "current" : "done";
  };

  return (
    <div className="steps">
      {currentIndex !== -1 && (
        <p className="steps-state">
          Étape {currentIndex + 1} sur {total}
        </p>
      )}
      <ol className="steps-list" aria-label="Étapes du parcours">
        {sections.map((s, index) => {
          const status = statusOf(index);
          return (
            <li
              key={"step-" + index}
              className={"steps-item is-" + status}
              aria-current={status === "current" ? "step" : undefined}
            >
              <span className="steps-marker" aria-hidden="true">
                {status === "done" ? <i className="fa fa-check" /> : index + 1}
              </span>
              {status === "done" && <span className="sr-only">Étape terminée :</span>}
              <span className="steps-label">{s.title}</span>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default ProgressSection;
